<template>
  <div id="app">
    <transition name="page-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
@import './assets/styles/transition.less';
@import './assets/styles/theme.less'; // [ext] inject config.less as global setting
</style>



// WEBPACK FOOTER //
// src/app.vue